<template>
  <ul class="small-information-list">
    <li v-if="showSpecificDonation">
      <v-icon class="bullet-arrow">{{ icons.mdiArrowRight }}</v-icon
      >Specific donation
    </li>
    <li v-if="showPortiononRemainder">
      <v-icon class="bullet-arrow">{{ icons.mdiArrowRight }}</v-icon
      >Portion of remainder
    </li>
    <li v-if="showAlternativeHeir">
      <v-icon class="bullet-arrow">{{ icons.mdiArrowRight }}</v-icon
      >{{
        this.beneficiary.__typename === 'Person'
          ? 'Alternative heir of remainder'
          : `Alternative ${this.beneficiary.__typename?.toLowerCase()} of remainder`
      }}
    </li>
    <li v-if="showNoDonation">
      <v-icon class="bullet-arrow">{{ icons.mdiArrowRight }}</v-icon
      >No donation assigned yet
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'BeneficiaryDonationDetails',
    props: {
      beneficiary: {
        required: true,
        type: Object,
      },
    },
    computed: {
      showSpecificDonation() {
        return this.beneficiary.specificDonations.length > 0;
      },
      showPortiononRemainder() {
        return this.beneficiary.distributionSpecificPercentage;
      },
      showAlternativeHeir() {
        return (
          this.beneficiary.distributionSpecificPercentageAlternatives.length >
            0 ||
          this.beneficiary.alternativeDistributionSpecificPercentage ||
          this.beneficiary
            .distributionSpecificPercentageAlternativeBeneficiaries?.length > 0
        );
      },
      showPortiononRemainder() {
        return this.beneficiary.distributionSpecificPercentage;
      },
      showAlternativeHeir() {
        return (
          this.beneficiary.distributionSpecificPercentageAlternatives?.length >
            0 ||
          this.beneficiary.alternativeDistributionSpecificPercentage ||
          this.beneficiary
            .distributionSpecificPercentageAlternativeBeneficiaries?.length > 0
        );
      },
      showNoDonation() {
        return (
          !this.showSpecificDonation &&
          !this.showPortiononRemainder &&
          !this.showAlternativeHeir
        );
      },
    },
  };
</script>
